const MAX_W = 360;
const MAX_H = 480;

/** Fit a sent image inside the chat column without cropping or leaving a blank frame. */
export function fitChatImageSize(
  naturalW: number,
  naturalH: number,
): { width: number; height: number } {
  if (naturalW <= 0 || naturalH <= 0) return { width: 240, height: 160 };
  const scale = Math.min(1, MAX_W / naturalW, MAX_H / naturalH);
  return {
    width: Math.max(1, Math.round(naturalW * scale)),
    height: Math.max(1, Math.round(naturalH * scale)),
  };
}
